import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';
import {RateTypeModel} from '../../../../models/RateTypeModel';
import {RateTypeAnagrafService} from 'src/app/general-services/service-rate-type/rate-type-anagraf.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-rate-type-filter',
  templateUrl: './rate-type-filter.component.html',
  styleUrls: ['./rate-type-filter.component.scss']
})
export class RateTypeFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listFilterRateType: any;
  getAllRateTypeSubscribe: Subscription;

  @Input() rateTypeSelected: RateTypeModel;

  constructor(private rateTypeService: RateTypeAnagrafService) {
    super();
  }

  ngOnInit() {
    this.getAll();
  }
S
  ngOnChanges(changes: SimpleChanges) {
    if ('rateTypeData' in changes) {
      this.optionSelected = this.listFilterRateType ? this.listFilterRateType[0] : null;
    }
    if (this.rateTypeSelected) {
      this.optionSelected = this.rateTypeSelected;
    }
  }

  getAll() {
    this.getAllRateTypeSubscribe = this.rateTypeService.getList()
      .subscribe(
        (result: any) => {
          this.listFilterRateType = result;
        });
  }

  ngOnDestroy(): void {
  }
}

